<template>
  <div class="yxxsc" v-if="kbxmlc">
    <template v-if="role == 'Z'">
      <div :class="['box', kbxmlc.zt == '2' || !isChose ? 'noBtn' : '']">
        <p class="cont-title">有效性审查</p>
        <div class="ddscBox">
          <div v-if="!isChose">
            <p>请选择审查方式</p>
            <div class="scfsBtn">
              <el-radio-group v-model="scfs">
                <el-radio :label="1">系统自动审查</el-radio>
                <el-radio :label="2">人工审查</el-radio>
              </el-radio-group>
            </div>
            <div>
              <el-button type="primary" @click="saveScfs">进入保证金审查</el-button>
            </div>
          </div>
          <template v-else>
            <h2 v-if="sfqrscjg">审查已完成，请各投标单位自行查看审查结果！</h2>
            <h2 v-else>请等待审查结束！</h2>
          </template>
        </div>
      </div>
      <el-button
        type="primary lcNext"
        :disabled="!sfqrscjg || waitLoading"
        @click="nextBtn"
        v-if="kbxmlc.zt != '2' && isChose"
        >下一步</el-button
      >
    </template>
    <div class="box noBtn" v-else>
      <div class="clear">
        <p class="cont-title lf">有效性审查</p>
        <div class="rt">
          <el-select
            v-model="sfjnbzj"
            placeholder="保证金"
            style="width: 100px; float: left"
            @change="serachData"
          >
            <el-option
              v-for="item in sfjnbzjOptions"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="kbsczt"
            placeholder="审查结果"
            style="width: 100px; float: left; margin-left: 10px"
            @change="serachData"
          >
            <el-option
              v-for="item in kbscztOptions"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-input
            v-model="tbdwmc"
            class="input-with-select lf"
            style="width: 250px; margin: 0 10px"
            placeholder="投标单位名称"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="serachData"
            ></el-button>
          </el-input>
          <el-button
            v-if="role == 'T' || role == 'A'"
            type="primary"
            @click="allPass"
            :disabled="kbxmlc.zt == '2' || scfs != '2' || sfqrscjg"
            >一键通过</el-button
          >
          <el-button
            v-if="role == 'T' || role == 'A'"
            type="primary"
            @click="qdsc"
            :disabled="kbxmlc.zt == '2' || !sfscws || scfs != '2' || sfqrscjg"
            >提交审查结果</el-button
          >
        </div>
      </div>
      <el-table
        ref="table"
        @selection-change="handleSelectionChange"
        border
        :data="tableData"
        style="width: 100%"
        max-height="570"
      >
        <el-table-column type="selection" width="40" :selectable="selectable"></el-table-column>
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column
          prop="fCQYMC"
          label="投标单位名称"
          show-overflow-tooltip
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="fDBSSCSJ"
          label="投标文件递交时间"
          sortable
          width="170"
        ></el-table-column>
        <el-table-column
            prop="fCBZJLX"
            label="保证金缴纳方式"
            width="120"
            :formatter="jnfsFormatter"
          ></el-table-column>
        <template v-if="scfs == '2'">
          <el-table-column
            prop="sFJNBZJ"
            label="保证金"
            width="80"
            :formatter="bzjFormatter"
          ></el-table-column>
        </template>
        <el-table-column
          prop="kbsczt"
          label="审查结果"
          width="80"
          :formatter="scjgFormatter"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          width="80"
          v-if="(role == 'T' || role == 'A')&&kbxmlc.zt == '1'"
        >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="sc(scope.row)"
            :disabled="kbxmlc.zt == '2' || !sfscws || scfs != '2' || sfqrscjg"
            >审查</el-button>
        </template>
        </el-table-column>
        <el-table-column
          prop="bz"
          label="备注"
          width="170"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <div class="clear">
        <span class="lf pageNum"
          >共{{ total }}家，审查通过{{ sctg }}家，审查未通过{{
            scbtg
          }}家，剩余{{ total - sctg - scbtg }}家</span
        >
      </div>
      <!-- 审查弹窗 -->
      <el-dialog
        title="审查"
        :visible.sync="dialogFormVisible"
        width="600px"
        :before-close="cancleForm"
        :close-on-click-modal="false"
      >
        <el-form :model="form" ref="form" label-width="100px" :rules="rules">
          <el-form-item label="被审查企业">
            {{form.name}}
          </el-form-item>
          <el-form-item label="缴纳状态" prop="sfjnbzj">
            <el-radio-group v-model="form.sfjnbzj">
              <el-radio :label="1">已缴纳</el-radio>
              <el-radio :label="0">未缴纳</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="缴纳方式">
            线下保函
          </el-form-item> -->
          <el-form-item label="审查结果" prop="kbsczt">
            <el-radio-group v-model="form.kbsczt">
              <el-radio label="1">通过</el-radio>
              <el-radio label="2">不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注" prop="bz">
            <el-input type="textarea" v-model="form.bz"></el-input>
          </el-form-item>
        </el-form>
        <div class="btnBox">
          <el-button type="primary" @click="saveForm('form')" :loading='waitLoading'>提交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "yxxsc",
  components: {},
  data() {
    var _this = this;
    var myValidate = function (rule, value, callback) {
      if(!value&&value!==0){
        if((_this.form.sfjnbzj == 1&&_this.form.kbsczt == 2)||(_this.form.sfjnbzj == 0&&_this.form.kbsczt == 1)){
          callback(new Error("必填项"));
        }else{
          callback();
        }
      }else{
        callback();
      }
    };
    return {
      waitLoading: false,
      kbxmlc: "",
      djlcId: "", //当前节点状态
      tableData: [],
      sctg: 0,
      scbtg: 0,
      tbdwmc: "",
      total: 0,
      multipleSelection: [], //表格选择
      kbscztOptions: [
        { value: "qb", text: "全部" },
        { value: "1", text: "通过" },
        { value: "2", text: "不通过" },
        { value: "0", text: "待审查" },
      ],
      kbsczt: "",
      sfjnbzjOptions: [
        { value: "qb", text: "全部" },
        { value: "1", text: "已缴纳" },
        { value: "0", text: "未缴纳" },
      ],
      sfjnbzj: "",
      dialogFormVisible: false,
      form: {},
      rules: {
        sfjnbzj: [{ required: true, message: "必填项", trigger: "change" }],
        kbsczt: [{ required: true, message: "必填项", trigger: "change" }],
        bz: [{ validator: myValidate, trigger: "blur" }],
      },
      flag: false,
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      scfs: "2", //审查方式
      isChose: false, //是否已经选择审查方式
      sfscws: false, //是否已经完成审查
      sfqrscjg: false,
      bzjState:'',// 保证金缴纳状态
      tipDom:'',// 提示弹窗
    };
  },
  methods: {
    getData() {
      let para = {
        djlcId: this.djlcId,
        tbdwmc: this.tbdwmc,
        kbsczt: this.kbsczt,
        sfjnbzj: this.sfjnbzj,
      };
      this.waitLoading = true;
      this.$api
        .yxxsc(para)
        .then((res) => {
          if (res.data.meta.success) {
            console.log('ss',res.data.data.tbdwList);
            this.tableData = res.data.data.tbdwList;
            this.bzjState=this.tableData.some((item)=>{
              return item.sFJNBZJ==0
            })
            this.total = res.data.data.total;
            this.sctg = res.data.data.sctgSize;
            this.scbtg = res.data.data.scwtgSize;
            if (res.data.data.kbxm.scfs) {
              this.scfs = res.data.data.kbxm.scfs;
              this.sfqrscjg =
                res.data.data.kbxm.yxxscsfqr == "1" ? true : false;
              this.isChose = true;
              this.sfscws = res.data.data.yxxscSfwc; //已经审查完成可以确认
            } else {
              this.isChose = false;
            }
            this.kbxmlc = res.data.data.kbxmlc;
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    //查询
    serachData() {
      this.getData();
    },
    saveScfs() {
      let para = {
        scfs: this.scfs,
      };
      this.waitLoading = true;
      this.$api
        .saveScfs(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.isChose = true;
            if (this.scfs == 1) {
              this.sfqrscjg = true;
              let obj = {
                lx: "zb",
                data: {},
              };
              this.$emit("send", JSON.stringify(obj));
            } else {
              this.sfqrscjg = false;
              let obj = {
                lx: "zbr",
                data: {},
              };
              this.$emit("send", JSON.stringify(obj));
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    //审查弹窗
    sc(row) {
      this.dialogFormVisible = true;
      this.form = {
        sfjnbzj: row.sFJNBZJ,
        jnfs: row.fCBZJLX,
        kbsczt: row.kbsczt==0?'':row.kbsczt,
        bz: row.bz,
        id:row.id,
        name:row.fCQYMC
      };
    },
    cancleForm() {
      this.form = {
        sfjnbzj: "",
        jnfs: "",
        kbsczt: "",
        bz: "",
        id:'',
        name:''
      };
      this.$refs.form.resetFields();
      this.dialogFormVisible = false;
      this.flag = false;
    },
    //一键通过
    allPass(){
      if (this.multipleSelection.length) {
        this.$confirm('请确认是否一键通过所选的投标单位？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.oneClickPassCensor()
        }).catch(() => {});
      }else{
        this.$message.warning('请选择投标单位！')
      }
    },
    oneClickPassCensor(){
      let para={}
      let ids=''
      this.multipleSelection.forEach((obj, index) => {
        if (index == this.multipleSelection.length - 1) {
          ids += obj.id;
        } else {
          ids += obj.id + ",";
        }
      });
      para.ids = ids;
      this.waitLoading = true;
      this.$api.oneClickPassCensor(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.getData();
            this.$message({
              type: "success",
              message: "保存成功！",
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {this.waitLoading = false;});
    },
    //提交审查
    saveForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.waitLoading = true;
          let {sfjnbzj,kbsczt,bz,id}={...this.form}
          let para = {
            sfjnbzj,kbsczt,bz,id
          }
          // let ids = "";
          // let jgdms = "";
          // this.multipleSelection.forEach((obj, index) => {
          //   if (index == this.multipleSelection.length - 1) {
          //     ids += obj.id;
          //     jgdms += obj.fCQYJGDM;
          //   } else {
          //     ids += obj.id + ",";
          //     jgdms += obj.fCQYJGDM + ",";
          //   }
          // });
          // para.ids = ids;
          this.$api
            .saveYxxsc(para)
            .then((res) => {
              if (res.data.meta.success) {
                this.dialogFormVisible = false;
                this.getData();
                this.$message({
                  type: "success",
                  message: "保存成功！",
                });
                this.$refs.form.resetFields();
              }
              this.waitLoading = false;
            })
            .catch(() => {this.waitLoading = false;});
        } else {
          return false;
        }
      });
    },
    //确定审查全部完成，通知主持人，可以下一步操作
    qdsc() {
      this.$confirm("是否确认提交审查结果？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let para = {};
          this.waitLoading = true;
          this.$api
            .qdscjg(para)
            .then((res) => {
              if (res.data.meta.success) {
                let obj = {
                  lx: "kbzcr",
                  data: {},
                };
                this.$emit("send", JSON.stringify(obj));
                this.sfqrscjg = true;
              }
              this.waitLoading = false;
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    bzjFormatter(row, column, cellValue, index) {
      switch (row.sFJNBZJ) {
        case 0:
          return "未缴纳";
          break;
        case 1:
          return "已缴纳";
          break;
        default:
          return "";
          break;
      }
    },
    scjgFormatter(row, column, cellValue, index) {
      switch (row.kbsczt) {
        case "0":
          return "未审查";
          break;
        case "1":
          return "通过";
          break;
        case "2":
          return "不通过";
          break;
        default:
          return "未审查";
          break;
      }
    },
    jnfsFormatter(row, column, cellValue, index){
      switch (row.fCBZJLX) {
        case "0":
          return "保证金转账";
          break;
        case "1":
          return "电子保函";
          break;
        case "2":
          return "其他";
          break;
        case "3":
          return "线下保函";
          break;
        default:
          return "";
          break;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    nextBtn() {
      let para = {
        flag: this.kbxmlc.ycdz,
      };
      this.waitLoading = true;
      this.$emit("nextBtn", para);
    },
    selectable(row,index){
      return true
    }
  },
  mounted() {
    this.djlcId = this.$route.query.djlcId;
    this.getData();
  },
};
</script>
<style lang="less">
.yxxsc {
  .box {
    position: relative;
  }
  .msgBox {
    padding: 60px 80px 60px 100px;
    background: url("../assets/images/warning.png") no-repeat 40px 60px;
    h3 {
      font-size: 30px;
      color: #333;
      font-weight: 400;
      margin-bottom: 5px;
    }
    p {
      font-size: 16px;
      color: #333;
      span {
        color: @base-color;
        font-size: 24px;
      }
    }
  }
  .ddscBox {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    h2 {
      font-size: 36px;
      color: #333;
    }
    div {
      p {
        font-size: 18px;
        color: #333;
        margin-bottom: 60px;
      }
      .el-button {
        width: 180px;
        height: 42px;
        line-height: 42px;
      }
      div.scfsBtn {
        margin-bottom: 60px;
        button {
          width: 250px;
          height: 60px;
          line-height: 60px;
          padding: 0;
          margin: 0 10px;
          font-size: 20px;
          color: @base-color;
          background: #fff;
          border: 1px solid @base-color !important;
        }
        button.active {
          background: @base-color;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
}

.scfsBtn .el-radio__inner {
  border: 1px solid #666;
  width: 16px;
  height: 16px;
  background-color: #f3f3f3;
}

.scfsBtn .el-radio__inner:hover {
  border-color: #0060B2;
}

.scfsBtn .el-radio__input.is-checked .el-radio__inner {
  border-color: #0060B2;
  background-color: #f3f3f3;
}

.scfsBtn .el-radio__inner::after {
    width: 10px;
    height: 10px;
    background-color: #0060B2;
}

.scfsBtn .el-radio__input.is-checked + .el-radio__label {
    color: #0060B2;
}
</style>